<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              ref="name"
              type="text"
              name="name"
              label="نام دسته بندی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
          </div>
        </div>
      </bita-form>
      <div slot="footer" class="d-flex flex-column flex-md-row k-gap-2">
        <div class="col-12 col-md-2 p-0" v-if="!propsData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2 p-0" v-if="propsData.id">
          <bita-bootbutton
            type="primary"
            title="بروزرسانی"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2 px-md-5">
          <bita-bootbutton
            type="danger"
            title="بستن"
            icon="fas fa-times"
            class="w-100 bg-transparent border-0 text-danger"
            data-dismiss="modal"
            @click.native="
              () => {
                $emit('change-status-modal');
              }
            "
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
      },
    },
  },
  data() {
    return {
      colWidth: "col-12",
      form: {},
    };
  },
  watch: {
    propsData: function(_data) {
      this.form = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      if (this.$refs.name) this.$refs.name.emptyKendo();
      this.$refs.form.reset();
    },
  },
};
</script>
